import { CheckIcon, StarIcon } from '@heroicons/react/24/outline';
import { StarIcon as SolidStarIcon } from '@heroicons/react/24/solid';
import { ButtonHTMLAttributes, useEffect, useState } from 'react';

type LivescoreFavoriteCircleTogglerProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isFavorite: boolean;
};

const LivescoreFavoriteCircleToggler = ({ isFavorite, id, ...props }: LivescoreFavoriteCircleTogglerProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentState, setCurrentState] = useState(isFavorite);

  useEffect(() => {
    if (isFavorite !== currentState) {
      setIsVisible(false);
      const timer = setTimeout(() => {
        setCurrentState(isFavorite);
        setIsVisible(true);
      }, 100);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(true);
    }
  }, [isFavorite, currentState]);

  return (
    <button {...props} className="!w-5 !h-5 relative">
      <span
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-200 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
      >
        {currentState ? (
          <span className="w-5 h-5 rounded-full bg-primary-600 flex items-center justify-center">
            <CheckIcon stroke="#0F0F0F" width={11} strokeWidth={3.5} />
          </span>
        ) : (
          <div className="w-5 h-5 rounded-full border border-border-400" />
        )}
      </span>
      <p className="sr-only">Add match to favorites</p>
    </button>
  );
};

export default LivescoreFavoriteCircleToggler;
